const fmt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function Money({ value, muted }: { value: string | number; muted?: boolean }) {
  const n = typeof value === "string" ? Number(value) : value;
  return (
    <span className={`tabular-nums ${muted ? "text-slate-400" : ""}`}>
      {Number.isFinite(n) ? fmt.format(n) : "—"}
    </span>
  );
}
